export default {
  title: 'Sistema eFactura',
  unavailable: 'Lo sentimos, pero la url que ha solicitado no está disponible. Pongase en contacto con su proveedor.'
}
